import React from 'react';
import { Menu, Icon, Avatar, Spin, Tabs, Dropdown, Popover, Badge, List, message } from 'antd';
import groupBy from 'lodash/groupBy';
import moment from 'moment';
import common from '@/common/common.js';
import AuthMenu from '@/components/AuthMenu.js'
import request from '@/common/urequest'
import './RightMenu.less';

const { TabPane } = Tabs;
export default class RightMenu extends React.Component {
    state = {
        notices: [],
        count: 0,
        message: null,
        fetchingNotices: false,

        sysCount: null,
        noticeCount: null,
        wordCount: null,
        visible: false,
    }

    componentWillMount() {
        this.queryCountMessage();
        this.myinterval = setInterval(() => { this.queryCountMessage(); }, 15000);
    }

    componentWillUnmount() {
        clearInterval(this.myinterval);
    }

    getNoticeData() {
        const { notices = [] } = this.state;
        if (!notices || notices.length === 0) {
            return {};
        }
        const newNotices = notices.map(notice => {
            const newNotice = { ...notice };
            if (newNotice.createTime) {
                newNotice.datetime = moment(notice.createTime).fromNow();
            }
            if (newNotice.id) {
                newNotice.key = newNotice.id;
            }
            // if (newNotice.extra && newNotice.status) {
            //     const color = {
            //         todo: '',
            //         processing: 'blue',
            //         urgent: 'red',
            //         doing: 'gold',
            //     }[newNotice.status];
            //     newNotice.extra = (
            //         <Tag color={color} style={{ marginRight: 0 }}>
            //             {newNotice.extra}
            //         </Tag>
            //     );
            // }
            return newNotice;
        });
        return groupBy(newNotices, 'type');
    }

    queryCountMessage = () => {
        const that = this;
        request('message/queryCountMessage.action', {
            method: 'POST',
            requestType: 'form'
        }).then(d => {
            if (d != null) {
                if (d.status && d.status == "error") {
                    message.warning(d.info);
                    return false;
                }
                that.setState({ count: d });
            }
        });
    }


    queryNewMessage = () => {
        const that = this;
        request('message/queryNewMessage.action', {
            method: 'POST',
            requestType: 'form'
        }).then(d => {
            if (d) {
                if (d.status && d.status == "error") {
                    message.warning(d.info);
                    return;
                }
            }
            that.setState({ message: d });
        });
    }

    onNoticeVisibleChange = visible => {
        this.setState({ visible });
        if (visible) {
            this.setState({ fetchingNotices: true });
            this.queryMessage();
        }
    }

    queryMessage = () => {
        const that = this;
        request('message/findTop5Notice.action', {
            method: 'POST',
            requestType: 'form'
        }).then(d => {
            let notices = [];
            if (d) {
                if (d.status && d.status == "error") {
                    message.error(d.info);
                    return false;
                }
                notices = d;
            }
            that.setState({ notices });
        }).finally(() => {
            that.setState({ fetchingNotices: false });
        });
        request('message/queryMessageClassifysCount.action', {
            method: 'POST',
            requestType: 'form'
        }).then(d => {
            if (d) {
                if (d.status && d.status == "error") {
                    message.error(d.info);
                    return false;
                }
                const { sys, notice, word } = d;
                that.setState({
                    sysCount: sys,
                    noticeCount: notice,
                    wordCount: word,
                });
            }
        });
    }

    toMoreMessage = (key) => {
        if (key === 'notification') {
            this.props.history.push({
                pathname: '/message/config/history',
                state: { activeKey: common.SYS_MESSAGE }
            });
        }
        if (key === 'message') {
            this.props.history.push({
                pathname: '/message/config/history',
                state: { activeKey: common.NOTICE_MESSAGE }
            });
        }
        if (key === 'event') {
            this.props.history.push({
                pathname: '/message/config/history',
                state: { activeKey: common.BUSINESS_MESSAGE }
            });
        }
    }

    onWordItemClick = (item) => {
        this.setState({ visible: false });
        const that = this;
        let params = {
            'record.id': item.id
        };
        request('appvendmsginfos/updateMsg.action', {
            method: 'POST',
            requestType: 'form',
            data: params
        }).then(d => {

            if (d && d.status == "success") {
                if (item.type === 'word') {
                    that.props.history.push({
                        pathname: "/message/detail",
                        state: {
                            id: item.id,
                            type: common.BUSINESS_MESSAGE,
                        },
                    });
                }
                that.queryMessage();
            }
        }).finally(() => {
            that.queryCountMessage();
        });
    }

    onItemClick = item => {
        this.setState({ visible: false });
        const that = this;
        let params = {
            'message.id': item.id
        };
        request('message/updateMesage.action', {
            method: 'POST',
            requestType: 'form',
            data: params
        }).then(d => {
            if (d && d.status == "error") {
                message.error(d.info);
            }
        }).finally(() => {
            that.queryCountMessage();
            that.queryMessage();
        });
        if (item.type === 'sys') {
            this.props.history.push({
                pathname: "/message/detail",
                state: {
                    id: item.id,
                    type: common.SYS_MESSAGE,
                },
            });
        }
        if (item.type === 'notice') {
            this.props.history.push({
                pathname: "/message/detail",
                state: {
                    id: item.id,
                    type: common.NOTICE_MESSAGE,
                },
            });
        }
    }

    render() {
        const { currentUser, onMenuClick } = this.props;
        const { fetchingNotices, count, sysCount, noticeCount, wordCount, visible } = this.state;
        const noticeData = this.getNoticeData();
        const menu = (
            <Menu className={'menu'} selectedKeys={[]} onClick={onMenuClick}>
                <Menu.Item key="logout">
                    <Icon type="logout" />
                    <span>退出登录</span>
                </Menu.Item>
            </Menu>
        );
        const moreSys = (<div className="more-notice">
            <div className="more-notice-button" onClick={() => this.toMoreMessage('notification')}>更多平台消息</div>
        </div>);
        const moreNotice = (<div className="more-notice">
            <div className="more-notice-button" onClick={() => this.toMoreMessage('message')}>更多通知</div>
        </div>);
        const moreWord = (<div className="more-notice">
            <div className="more-notice-button" onClick={() => this.toMoreMessage('event')}>更多业务消息</div>
        </div>);
        const noticeTabs = (
            <Spin spinning={fetchingNotices} delay={500}>
                <Tabs defaultActiveKey="notification">
                    <TabPane tab={`平台消息 ${noticeData.sys ? `(${sysCount || ''})` : ''}`} key="notification">
                        {noticeData.sys ? <List
                            itemLayout="horizontal"
                            className="menu-top-right-notice"
                            dataSource={noticeData.sys}
                            loadMore={moreSys}
                            renderItem={item => (
                                <List.Item onClick={() => this.onItemClick(item)}>
                                    <List.Item.Meta
                                        title={item.title}
                                        description={item.datetime}
                                    />
                                </List.Item>
                            )}
                        /> :
                            <div className="empty-message">
                                <div className="empty-message-img">
                                    <img src={require("../img/wAhyIChODzsoKIOBHcBk.svg")}></img>
                                </div>
                                <div className="empty-message-text">
                                    暂无最新平台消息
                            </div>
                            </div>
                        }
                    </TabPane>
                    <TabPane tab={`通知 ${noticeData.notice ? `(${noticeCount || ''})` : ''}`} key="message">
                        {noticeData.notice ? <List
                            itemLayout="horizontal"
                            className="menu-top-right-notice"
                            dataSource={noticeData.notice}
                            loadMore={moreNotice}
                            renderItem={item => (
                                <List.Item onClick={() => this.onItemClick(item)}>
                                    <List.Item.Meta
                                        title={item.title}
                                        description={item.datetime}
                                    />
                                </List.Item>
                            )}
                        /> :
                            <div className="empty-message">
                                <div className="empty-message-img">
                                    <img src={require("../img/sAuJeJzSKbUmHfBQRzmZ.svg")}></img>
                                </div>
                                <div className="empty-message-text">
                                    暂无最新通知
                            </div>
                            </div>}
                    </TabPane>
                    <TabPane tab={`业务 ${noticeData.word ? `(${wordCount || ''})` : ''}`} key="event">
                        {noticeData.word ? <List
                            itemLayout="horizontal"
                            dataSource={noticeData.word}
                            loadMore={moreWord}
                            className="menu-top-right-notice"
                            renderItem={item => (
                                <List.Item onClick={() => this.onWordItemClick(item)}>
                                    <List.Item.Meta
                                        title={item.title}
                                        description={item.datetime}
                                    />
                                </List.Item>
                            )}
                        /> :
                            <div className="empty-message">
                                <div className="empty-message-img">
                                    <img src={require("../img/HsIsxMZiWKrNUavQUXqx.svg")}></img>
                                </div>
                                <div className="empty-message-text">
                                    暂无最新业务消息
                            </div>
                            </div>
                        }
                    </TabPane>
                </Tabs>
            </Spin>
        )
        return (
            <div className="right dark">
                <Popover
                    content={noticeTabs}
                    overlayClassName="menu-top-right-popover-overlay"
                    placement="bottomRight"
                    trigger="click"
                    visible={visible}
                    onVisibleChange={this.onNoticeVisibleChange}
                >
                    <span className="right-menu-notice">
                        <Badge count={count}>
                            <Icon type="bell" />
                        </Badge>
                    </span>
                </Popover>
                {
                    (currentUser && currentUser.userName) ? (
                        <Dropdown overlay={menu}>
                            <span className={`${'action'} ${'account'}`}>
                                <Avatar
                                    size="small"
                                    className={'avatar'}
                                    // src={currentUser.avatar}
                                    icon="user"
                                    alt="avatar"
                                />
                                <span className={'name'}>{currentUser.userName}</span>
                            </span>
                        </Dropdown>) : (
                            <Spin size="small" style={{ marginLeft: 8, marginRight: 8 }} />
                        )
                }
            </div>
        )
    }
}